import {get} from 'lodash';

export default (state = {}, {customer_id, data}: any) => {
  return {
    ...state,
    allMswlData: {
      ...get(state, 'allMswlData', {}),
      [customer_id]: data,
    },
  };
};
